<template>
  <BlokkliProvider v-slot="{ entity }" v-bind="blokkliProps" :entity="props">
    <div class="node-news">
      <PageHeader
        :tagline="topic"
        :title="entity?.title || title"
        :lead="entity?.intro || intro"
        :teaser-image="entity?.teaserImage || teaserImage"
        :inverted="hasBackground"
      />

      <section v-if="bodyText" class="page-content bg-gray-50">
        <div class="container">
          <div class="ck-content" v-html="bodyText" />
        </div>
      </section>

      <div class="bg-gray-50">
        <BlokkliField :list="paragraphs" name="field_paragraphs" />
      </div>

      <section v-if="contactPerson" class="section">
        <div class="container">
          <section-title
            :title="
              $texts('contactPersonForQueries', 'Contact person for queries')
            "
          />
        </div>

        <div class="is-wide container">
          <overlayed-teaser :media="contactPersonMedia">
            <person-card v-bind="contactPerson" class="card" />
          </overlayed-teaser>
        </div>
      </section>
    </div>
  </BlokkliProvider>
</template>

<script lang="ts" setup>
import type { NodeNewsFragment, MediaImageFragment } from '#graphql-operations'

const props = defineProps<{
  __typename?: string
  title?: string
  intro?: string
  body?: string
  teaserImage?: MediaImageFragment
  paragraphs?: NodeNewsFragment['paragraphs']
  blokkliProps: NodeNewsFragment['blokkliProps']
  hasBackground?: boolean
  pageColor?: NodeNewsFragment['highlightColor']
  publishedAtDate?: NodeNewsFragment['publishedAtDate']
  referencedTopic?: NodeNewsFragment['referencedTopic']
  author?: NodeNewsFragment['author']
  referencedContactPerson?: NodeNewsFragment['referencedContactPerson']
}>()

const bodyText = computed((): string => {
  return props.body || ''
})
const topic = computed((): string => {
  return props.referencedTopic?.topiclabel || ''
})

const contactPerson = computed(() => {
  const entity = props.referencedContactPerson
  return entity && entity.__typename === 'StoragePerson' ? entity : undefined
})

const contactPersonMedia = computed(() => {
  return contactPerson.value?.image as MediaImageFragment
})

const { hasBackground, htmlClasses } = usePageState(props)

useHead({
  htmlAttrs: {
    class: htmlClasses,
  },
})
</script>
